export const tokenAdd = '0x9517Ca8c05F6d723796B896eEBA417d9c9Fe9999'; // token stake address
export const tokenRewardAdd = '0xc2132D05D31c914a87C6611C10748AEb04B58e8F'; // token reward address
export const contractAddr1 = '0x3c47D1d08f99345aD4c84b4086a9DAF8F9055de3'; // stake address
export const contractAddr2 = '0xbbF2b35f9058b6BC3f18a42007852b5f48502C4a'; // stake address
export const contractAddr3 = '0xB65586357571D8B56CaFf80285fe754036E8D4EF'; // stake address
export const newTokenAdd = '0x88CE5800627f8706edf085Bee4fB0bDAF45B8888'; // new ip token address
export const swapAdd = '0x3D744F6bD07c5c838B76EaCF4726D8755679909c'; // swap contract address
export const ipcSwapAdd = '0xA0a8F04dcb8E08a60e9f7907FEbeBD3E519F1684'; // ipcswap contract address
export const oldToken = '0x88CE5800627f8706edf085Bee4fB0bDAF45B8888'; // old token ipcswap ip assets
export const newToken = '0x77BA3A95edF2FD1cb712cDc80616dC7035eD7777'; // new token ipcswap ipc
export const chainId = 137; // chain id
